export const fileTitles = [{
    name: 'sign.jpg',
    alt: "Our Sign"
  },
  {
    name: 'staff-kids.jpg',
    alt: "Our staff with kids"
  },
  {
    name: 'study.jpg',
    alt: "Kids Study"
  },
  {
    name: 'award-lady.jpg',
    alt: 'Lady Awarded'
  },
  {
    name: 'book-kid.jpg',
    alt: 'Kids with books'
  },
  {
    name: 'food-2.jpg',
    alt: 'Giving out food'
  },
  {
    name: 'food.jpg',
    alt: 'More food spread'
  },
  {
    name: 'house.jpg',
    alt: 'Typical house in slums'
  },
  {
    name: 'kid-dad.jpg',
    alt: 'Parents with kids'
  },
  {
    name: 'kid-group.jpg',
    alt: 'kids huddled up'
  },
  {
    name: "kids-books.jpg",
    alt: 'kids with books'
  },
  {
    name: 'kids-many.jpg',
    alt: 'kids in a group'
  },
  {
    name: "kids-more.jpg",
    alt: 'more kids in a group'
  },
  {
    name: 'kids-poor.jpg',
    alt: 'Poor kids'
  },
  {
    name: 'kids-sit.jpg',
    alt: 'Kids sitting and drawing'
  },
  {
    name: 'kids.jpg',
    alt: "Kids in Slums"
  },
  {
    name: 'lady-happy.jpg',
    alt: "Slum lady volunteer"
  },
  {
    name: 'parents-kids.jpg',
    alt: "Parents and their kids"
  },
  {
    name: 'partap.jpg',
    alt: "Team member Helping"
  },
  {
    name: 'partap-2.jpg',
    alt: "Giving out notebooks"
  },
  {
    name: 'path.jpg',
    alt: "path to the slum"
  },
  {
    name: 'posing.jpg',
    alt: "awarding a child"
  }, {
    name: 'preaching.jpg',
    alt: "Motivating kids"
  }, {
    name: 'preaching-2.jpg',
    alt: "Sharing experiences with kids"
  }
];



// WEBPACK FOOTER //
// ./src/components/Events/Wad/Wad-data.js